import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    PhoneOutlined,
    MailOutlined,
    EnvironmentOutlined,
    ClockCircleOutlined,
    FacebookOutlined,
    LinkedinOutlined,
    InstagramOutlined,
    WhatsAppOutlined,
    RightOutlined,
    SafetyCertificateOutlined,
} from '@ant-design/icons';
import logo from '../../assets/logo/logo-cap-assurances.JPG';
import './Footer.scss';

export default function SiteFooter() {
    const navigate = useNavigate();

    const goTo = (path) => {
        navigate(path);
        window.scrollTo(0, 0);
    };

    return (
        <footer className="site-footer">
            {/* Main footer */}
            <div className="footer-main">
                <div className="footer-inner">
                    <div className="footer-grid">
                        {/* Col 1: Brand */}
                        <div className="footer-col brand-col">
                            <div className="footer-brand">
                                <img src={logo} alt="CAP Assurances" className="footer-logo" />
                            </div>
                            <p className="brand-desc">
                                Societe de courtage d'assurances agreee, specialisee dans
                                l'accompagnement et le conseil en assurances pour les
                                particuliers et les entreprises en Cote d'Ivoire.
                            </p>
                            <div className="social-links">
                                <a href="#" className="social-link" aria-label="Facebook"><FacebookOutlined /></a>
                                <a href="#" className="social-link" aria-label="LinkedIn"><LinkedinOutlined /></a>
                                <a href="#" className="social-link" aria-label="Instagram"><InstagramOutlined /></a>
                                <a href="#" className="social-link whatsapp" aria-label="WhatsApp"><WhatsAppOutlined /></a>
                            </div>
                        </div>

                        {/* Col 2: Nos assurances */}
                        <div className="footer-col">
                            <h4 className="footer-heading">Nos assurances</h4>
                            <ul className="footer-links">
                                <li onClick={() => goTo('/assurances/auto')}><RightOutlined /> Automobile</li>
                                <li onClick={() => goTo('/assurances/habitation')}><RightOutlined /> Habitation</li>
                                <li onClick={() => goTo('/assurances/sante')}><RightOutlined /> Sante</li>
                                <li onClick={() => goTo('/assurances/chantier')}><RightOutlined /> Chantier</li>
                                <li onClick={() => goTo('/assurances/transport')}><RightOutlined /> Transport</li>
                                <li onClick={() => goTo('/assurances/plantation')}><RightOutlined /> Plantation</li>
                            </ul>
                        </div>

                        {/* Col 3: Liens utiles */}
                        <div className="footer-col">
                            <h4 className="footer-heading">Liens utiles</h4>
                            <ul className="footer-links">
                                <li onClick={() => goTo('/')}><RightOutlined /> Accueil</li>
                                <li onClick={() => goTo('/a-propos')}><RightOutlined /> A propos de nous</li>
                                <li onClick={() => goTo('/assurances')}><RightOutlined /> Toutes nos assurances</li>
                                <li onClick={() => goTo('/contact')}><RightOutlined /> Contact</li>
                                <li onClick={() => goTo('/connexion')}><RightOutlined /> Espace Client</li>
                            </ul>
                        </div>

                        {/* Col 4: Contact */}
                        <div className="footer-col">
                            <h4 className="footer-heading">Nous contacter</h4>
                            <div className="contact-list">
                                <div className="contact-item">
                                    <div className="contact-icon"><EnvironmentOutlined /></div>
                                    <div>
                                        <strong>Siege - 2 Plateaux Vallon</strong>
                                        <span>Abidjan, Cote d'Ivoire</span>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon"><EnvironmentOutlined /></div>
                                    <div>
                                        <strong>Agence Riviera Golf</strong>
                                        <span>Abidjan, Cote d'Ivoire</span>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon"><PhoneOutlined /></div>
                                    <div>
                                        <span>+225 07 00 00 00 00</span>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon"><MailOutlined /></div>
                                    <div>
                                        <span>contact@capassurances-sc.net</span>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon"><ClockCircleOutlined /></div>
                                    <div>
                                        <span>Lun - Ven : 8h00 - 17h30</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom bar */}
            <div className="footer-bottom">
                <div className="footer-inner">
                    <div className="bottom-content">
                        <div className="bottom-left">
                            <SafetyCertificateOutlined className="badge-icon" />
                            <span>Courtier d'assurances agree - Cote d'Ivoire</span>
                        </div>
                        <div className="bottom-center">
                            &copy; {new Date().getFullYear()} CAP Assurances. Tous droits reserves.
                        </div>
                        <div className="bottom-right">
                            <span onClick={() => goTo('/contact')}>Mentions legales</span>
                            <span className="sep">|</span>
                            <span onClick={() => goTo('/contact')}>Politique de confidentialite</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
